import ApprouveCell from "./ApprouveCell";
import CaracteristiquesCell from "./CaracteristiquesCell";
import EchantillonCell from "./EchantillonCell";
import FamilleWebCell from "./FamilleWebCell";
import ImageCell from "./ImageCell";
import InformationsCell from "./InformationsCell";
import PtrCell from "./PtrCell";
import StatusCell from "./StatusCell";

export const columns = [
    { title: "Actions", field: "actions", canInteract: false, wrapper: "actions" },
    { title: "Image", field: "documents", cell: ImageCell, canInteract: false },
    { title: "Famille", field: "couleurs", cell: FamilleWebCell, canInteract: false },
    { title: "Échantillon", field: "couleurs", cell: EchantillonCell, canInteract: false },
    { title: "Modèle", field: "mod_cd", canInteract: true },
    { title: "Fini", field: "fini_cd", canInteract: true },
    { title: "PTR", field: "prod_num", cell: PtrCell, canInteract: true },
    { title: "Groupe", field: "prod_groupe", canInteract: true },
    { title: "Collection", field: "prod_collection", canInteract: true },
    { title: "Description Web", field: "web_descr", canInteract: true },
    { title: "Approuvé", field: "approuve", cell: ApprouveCell, canInteract: false },
    { title: "Statuts", field: "statuts", cell: StatusCell, canInteract: false },
    { title: "Informations supplémentaires", field: "infos", cell: InformationsCell, canInteract: false },
    { title: "Caractéristiques", field: "caracteristiques", cell: CaracteristiquesCell, canInteract: false },
];